// extracted by mini-css-extract-plugin
export default {"wrapper":"LeadfamlyGamePage_wrapper__C0vim"};